import { Container } from 'react-bootstrap';
import PageSectionTitle from '../Layout/PageSectionTitle';
import Equation from '../Layout/Equation';
import MathJax from 'react-mathjax';
import "./AssumptionsTextContent.css";

const AssumptionsTextContent = (props) => {
  return(
    <div id="assumptions-text-content">
      <Container fluid className="con-no-pad">
        <MathJax.Provider>
          <section id="section1">
            <span>
              To make the estimands identifiable, our DGPs will satisfy the following assumptions:
            </span>
            <PageSectionTitle>
              Ignorability
            </PageSectionTitle>
            <span>
              Our DGPs will be free of unmeasured confounding. In the longitudinal context, this means there are no 
              unobserved covariates that relate to both treatment assignment and to the change in the untreated potential 
              outcome <MathJax.Node inline formula='Y_{it}(0)' /> from the period before the intervention (Years 1 and 2) 
              to the intervention period (Years 3 and 4):
            </span>
            <Equation tex='Y_{it_1}(0) - Y_{it_0}(0) \perp z_i \mid x_i \text{ for all } t_1: p_t=1, t_0: p_t=0' />
            <span>
              Note that ignorability does not preclude confounding by trends in the observed outcomes during the period before the 
              intervention, <MathJax.Node inline formula='Y_{i2} - Y_{i1}' />.</span>
          </section>
          
          <section id="section2">
            <PageSectionTitle id="trt-group">
              Overlap for treatment group
            </PageSectionTitle>
            <span>
              We assume overlap for the treatment group:
            </span>
            <Equation tex='P(z_i=1\mid x_{i} ) < 1 \text{ for all } i∶ z_i=1' />
          </section>
          
          <section id="section3">
            <PageSectionTitle>
              SUTVA
            </PageSectionTitle>
            <span>
              The stable unit treatment value assumption (SUTVA) states there is a single form of the treatment received by all 
              treated units and the outcome for each unit does not depend on the treatment assignment of others.
            </span>
          </section>
        </MathJax.Provider>
      </Container>
    </div>
  )
}

export default AssumptionsTextContent;
